import { backendServices } from './backendService';
import { web3Services } from './web3.service';

export const services = { ...backendServices, ...web3Services };
